<template>
  <div class="row">
    <div class="col-sm-12 col-md-12">
      <app-overlay-loader v-if="preloader" />
      <div class="card-body">
        <form
          class="mb-0"
          :class="{ 'loading-opacity': preloader }"
          ref="form"
          :data-url="selectedUrl ? `crud/${inputs.id}` : `crud`"
        >
        <div class="form-group row align-items-center">
            <label for="inputs_name" class="col-sm-2 mb-0">
              {{ $t("title") }}
            </label>
            <app-input
              id="inputs_name"
              class="col-sm-5"
              type="text"
              v-model="job.title"
              :read-only="true"
            />
            <label for="inputs_bid_range" class="col-sm-2 mb-0">
              {{ $t("bid_range") }}
            </label>
            <app-input
              id="inputs_bid_range"
              class="col-sm-3"
              type="text"
              v-model="job.bid_range +'/'+ job.range"
              :read-only="true"
            />
          </div>
          <div class="form-group row align-items-center">
            <label for="inputs_email" class="col-sm-3 mb-0">
              {{ $t("description") }}
            </label>
            <app-input
              id="inputs_email"
              class="col-sm-9"
              type="textarea"
              v-model="job.long_description"
              v-html="job.long_description"
              :read-only="true"
            />
          </div>
          <div class="form-group row align-items-center">
            <label for="inputs_email" class="col-sm-3 mb-0">
              {{ $t("short_description") }}
            </label>
            <app-input
              id="inputs_email"
              class="col-sm-9"
              type="textarea"
              v-model="job.short_description"
              :read-only="true"
            />
          </div>
          <div class="form-group row align-items-center">
            <label for="inputs_status" class="col-sm-3 mb-0">
              {{ $t("start_date") }}
            </label>
            <app-input
              id="inputs_status"
              class="col-sm-3"
              type="text"
              :read-only="true"
              v-model="job.start_date"
            />
            <label for="inputs_status" class="col-sm-3 mb-0">
              {{ $t("end_date") }}
            </label>
            <app-input
              id="inputs_status"
              class="col-sm-3"
              type="text"
              :read-only="true"
              v-model="job.end_date"
            />
          </div>
          <div class="form-group row align-items-center">
            <label for="inputs_status" class="col-sm-3 mb-0">
              {{ $t("job_type") }}
            </label>
            <app-input
              id="inputs_status"
              class="col-sm-3"
              type="select"
              :disabled="true"
              v-model="job.job_type"
              :list="jobTypeList"
            />
            <label for="inputs_status" class="col-sm-3 mb-0">
              {{ $t("job_status") }}
            </label>
            <app-input
              id="inputs_status"
              class="col-sm-3"
              type="text"
              :disabled="true"
              v-model="job.status"
            />
          </div>
           <div class="form-group row align-items-center">
              <label for="region" class="col-sm-3 mb-0">
                {{ $t("region") }}
              </label>
              <app-input
                id="region"
                class="col-sm-3"
                type="text"
                v-model="job.region"
                :disabled="true"
              />
              <label for="noticetype" class="col-sm-3 mb-0">
                {{ $t("notice_type") }}
              </label>
              <app-input
                id="noticetype"
                class="col-sm-3"
                type="text"
                v-model="job.notice"
                :disabled="true"
              />
            </div>
            <div class="form-group row align-items-center">
              <label for="threshold" class="col-sm-3 mb-0">
                {{ $t("threshold") }}
              </label>
              <app-input
                id="threshold"
                class="col-sm-3"
                type="text"
                v-model="job.threshold"
                :disabled="true"
              />
              <label for="framework" class="col-sm-3 mb-0">
                {{ $t("framework") }}
              </label>
              <app-input
                id="framework"
                class="col-sm-3"
                type="text"
                v-model="job.framework"
                :disabled="true"
              />
            </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { FormMixin } from "../../../../../../../core/mixins/form/FormMixin.js";
import {
  COMPANY_JOB_GET,
} from "../../../../../../Config/ApiUrl.js";
import { axiosGet } from "../../../../../../Helpers/AxiosHelper.js";

export default {
  name: "FormGrid",
  mixins: [FormMixin],
  data() {
    return {
      preloader: true,
      job: {},
      jobTypeList: [
        { id: "", value: "Choose One" },
        { id: "On-site", value: "On-site" },
        { id: "Hybrid", value: "Hybrid" },
        { id: "Remote", value: "Remote" },
      ],
      status: [
        { id: "", value: "Choose One" },
        { id: "draft", value: "Draft" },
        { id: "active", value: "Active" },
      ],
    };
  },
  methods: {
    getCustomerJob() {
      // let myLocation = location.href;
      // let split = myLocation.split("/");
      
      // let id = split[7].split("?")[0];
      let id = this.$attrs['props'].id;
        
      axiosGet(COMPANY_JOB_GET + "/" + id)
        .then((response) => {
          //   
          this.job = response.data;
          //   this.titleinvoice = response.data.company_name;
        })
        .catch((error) => {
          
        }).finally(() => {
          this.preloader = false;
        });
    },
  },
  mounted() {
    this.getCustomerJob();
  },
  computed: {
    userList() {
      return this.$store.state.user.loggedInUser;
    },
  },
};
</script>
